module.exports = __webpack_public_path__ + "static/img/bg-fr.ea309deb.png";